import store from "@/store/index";

//v-haveRoleFilter="["PRL", "KS"]" || v-haveRoleFilter.onlyKiosk="["PRL", "KS"]"
const haveRoleFilter = {
  inserted(el: Element, binding: any) {
    const profile = store.getters["shared/profile"];
    const isKiosk = store.getters["shared/isKiosk"];

    if (profile) {
      const onlyKiosk = binding.modifiers.onlyKiosk;

      if (!onlyKiosk || (onlyKiosk && isKiosk)) {
        //ALways add Admin
        const roles = ["Admin", ...binding.value];

        const test = roles.some((x) => {
          return profile.albumRoles.some((y) => {
            return y.toLowerCase() === x.toLowerCase();
          });
        });

        if (!test) {
          el.remove();
        }
      }
    } else {
      el.remove();
    }
  },
};

export default haveRoleFilter;
